// constants
import { CredExpInfoActionTypes } from './constants';
import { CredExpInfo as CredExpInfoData } from 'src/types/credExpInfo';

export type CredExpInfoActionType = {
    type:
        | CredExpInfoActionTypes.API_RESPONSE_SUCCESS
        | CredExpInfoActionTypes.API_RESPONSE_ERROR
        | CredExpInfoActionTypes.ADD_CRED_EXP_INFO
        | CredExpInfoActionTypes.EDIT_CRED_EXP_INFO
        | CredExpInfoActionTypes.GET_CRED_EXP_INFO
        | CredExpInfoActionTypes.GET_CRED_EXP_INFOS
        | CredExpInfoActionTypes.RESET
        | CredExpInfoActionTypes.RESET_SUCCESS
        | CredExpInfoActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const credExpInfoApiResponseSuccess = (
    actionType: string,
    data: CredExpInfoData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): CredExpInfoActionType => ({
    type: CredExpInfoActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const credExpInfoApiResponseError = (
    actionType: string,
    data: CredExpInfoData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): CredExpInfoActionType => ({
    type: CredExpInfoActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addCredExpInfo = (params: any): CredExpInfoActionType => ({
    type: CredExpInfoActionTypes.ADD_CRED_EXP_INFO,
    payload: params,
});

export const editCredExpInfo = (params: any): CredExpInfoActionType => ({
    type: CredExpInfoActionTypes.EDIT_CRED_EXP_INFO,
    payload: params,
});

export const GetCredExpInfos = (params: any): CredExpInfoActionType => ({
    type: CredExpInfoActionTypes.GET_CRED_EXP_INFOS,
    payload: params,
});

export const GetCredExpInfo = (params: any): CredExpInfoActionType => ({
    type: CredExpInfoActionTypes.GET_CRED_EXP_INFO,
    payload: params,
});

export const resetCredExpInfo = (): CredExpInfoActionType => ({
    type: CredExpInfoActionTypes.RESET,
    payload: {},
});

export const resetCredExpInfoSuccess = (): CredExpInfoActionType => ({
    type: CredExpInfoActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetCredExpInfoError = (): CredExpInfoActionType => ({
    type: CredExpInfoActionTypes.RESET_ERROR,
    payload: {},
});
